import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getSessionId() {
  let sid = sessionStorage.getItem('_vtk_sid');
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('_vtk_sid', sid);
  }
  return sid;
}

const VisitorTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Don't track admin pages
    if (path.startsWith('/admin')) return;

    const sid = getSessionId();
    const body = {
      session_id: sid,
      page_path: path,
      referrer: document.referrer || '',
    };

    fetch(`${BACKEND_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
